import { useAppSelector } from 'hooks/reduxHooks';

const useSelectBillingTrialExpired = () => {
  const billingPlan = useAppSelector((state) => state.account.account?.billing);
  const expired = useAppSelector((state) => state.main.expired);
  return {
    billingPlan,
    expired,
  };
};

export const useIsPlanTrial = () => {
  const { billingPlan } = useSelectBillingTrialExpired();
  return (billingPlan && billingPlan.planName === 'FREE_TRIAL') || false;
};

const useTrialExpired = () => {
  const { billingPlan, expired } = useSelectBillingTrialExpired();
  return (
    (billingPlan && billingPlan.planName === 'FREE_TRIAL' && expired) || false
  );
};

export const useTrialNotExpired = () => {
  const { billingPlan, expired } = useSelectBillingTrialExpired();
  return (
    (billingPlan && billingPlan.planName === 'FREE_TRIAL' && !expired) || false
  );
};

export default useTrialExpired;
